import { Spinner, SpinnerProps } from "@ps-design-system/components/Spinner";
import { cn } from "@ps-design-system/lib/utils";

type LoadingPageProps = {
  className?: string;
  spinnerProps?: SpinnerProps;
  testId?: string;
};

export const LoadingPage = ({
  className,
  spinnerProps,
  testId = "loading-page",
}: LoadingPageProps) => {
  return (
    <div
      data-testid={testId}
      className={cn(
        "tw-flex tw-w-screen tw-items-center tw-justify-center tw-h-[calc(100vh-4.5em)]", // 4.5em === 72px is the height of the navbar
        className,
      )}
    >
      <Spinner className="tw-size-28" appearance="gray" {...spinnerProps} />
    </div>
  );
};
